class CollectionContent extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.initButtonListeners();
    this.initCloseListeners();
    this.initSubmenuHoverListeners();
    this.initMenuClickListeners();
  }

  initButtonListeners() {
    this.addClickListener('[data-btn]', this.toggleSideMenu);
  }

  toggleSideMenu() {
    document.querySelector('[data-sidemenu]').classList.toggle('collection-content__side-menu--active');
  }

  initCloseListeners() {
    this.addClickListener('[data-close]', this.closeSideMenu);
    this.addClickListener('[data-overlay]', this.closeSideMenu);
  }

  closeSideMenu() {
    document.querySelector('[data-sidemenu]').classList.remove('collection-content__side-menu--active');
  }

  initSubmenuHoverListeners() {
    if (window.innerWidth > 1023) {
      document.querySelectorAll('[data-submenu-item]').forEach(item => {
        item.addEventListener('mouseenter', this.handleSubmenuMouseEnter.bind(this, item));
        item.addEventListener('mouseleave', this.handleSubmenuMouseLeave.bind(this, item));
      });
    }
  }

  handleSubmenuMouseEnter(item) {
    const index = item.getAttribute('data-submenu-item');
    const submenuImg = document.querySelector(`[data-submenu-img="${index}"]`);
    const submenuImages = document.querySelector('[data-submenu-images]');
    submenuImg.classList.add('collection-content__submenu-img-wrapper--active');
    submenuImages.classList.add('collection-content__submenu-images--active');
  }

  handleSubmenuMouseLeave(item) {
    const index = item.getAttribute('data-submenu-item');
    const submenuImg = document.querySelector(`[data-submenu-img="${index}"]`);
    const submenuImages = document.querySelector('[data-submenu-images]');
    submenuImg.classList.remove('collection-content__submenu-img-wrapper--active');
    submenuImages.classList.remove('collection-content__submenu-images--active');
  }

  initMenuClickListeners() {
    document.querySelectorAll('[data-menu-item]').forEach(item => {
      item.addEventListener('click', this.handleMenuClick.bind(this, item));
    });
  }

  handleMenuClick(item) {
    const index = item.getAttribute('data-menu-item');
    const submenu = document.querySelector(`[data-submenu="${index}"]`);
    const chevron = item.querySelector('[data-chevron]');

    this.closeAllSubmenusExcept(submenu);

    if (submenu.style.maxHeight) {
      submenu.style.maxHeight = null;
      chevron.classList.remove('chevron-down-icon--rotate');
    } else {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
      chevron.classList.add('chevron-down-icon--rotate');
    }
  }

  closeAllSubmenusExcept(exceptSubmenu) {
    document.querySelectorAll('[data-submenu]').forEach(submenu => {
      if (submenu !== exceptSubmenu) {
        submenu.style.maxHeight = null;
        const index = submenu.getAttribute('data-submenu');
        const chevron = document.querySelector(`[data-menu-item="${index}"] .chevron-down-icon`);
        if (chevron) {
          chevron.classList.remove('chevron-down-icon--rotate');
        }
      }
    });
  }

  addClickListener(selector, handler) {
    document.querySelector(selector).addEventListener('click', handler);
  }
}

customElements.define('collection-content', CollectionContent);
